<template>
    <div class="container">
        <div class="header">
            <slot name="header"></slot>
        </div>

        <div class="main">
            <div class="left-stance"></div>
            <el-main class="container">
                <transition mode="out-in" name="move">
                    <router-view></router-view>
                </transition>
            </el-main>
            <div class="right-stance"></div>
        </div>

        <div class="footer">
            <footer-bar></footer-bar>
        </div>
    </div>
</template>
<script>
    import FooterBar from '@/view/Footer'
    // noinspection JSUnusedGlobalSymbols
    export default {
        name: 'MainScaffold',
        components: {FooterBar}
    }
</script>

<style scoped>
    .container {
        /*background: #FAFAFA;*/
        min-height: 100%;
    }

    .main {
        padding: 30px 30px 0 30px;
        margin-top: 4rem;
        min-height: 30rem;
        margin-bottom: 7%;
        overflow: auto;
    }

    @media screen and (min-width: 1700px) {
        .left-stance {
            width: 6rem
        }

        .right-stance {
            width: 10rem
        }
    }

    @media screen  and (max-width: 900px) {
        .container {
            min-width: 900px;
        }

        .footer{
            position: static;
        }
    }

    .header {
        height: 20px;
    }

    .footer {
        left: 0;
        bottom: 0;
        width: 100%;
        text-align: center;
        position: relative;
    }
</style>
